import SFPoster from "./SFPoster";

export default SFPoster;



// WEBPACK FOOTER //
// ./js/components/SFPoster/index.js